import React, { useState } from 'react';

function RateEncryptDecrypt({ rateData,startSymbol="$",endSymbol="/hr" }) {
  const [showFee, setShowFee] = useState(false);
  const handleToggle = () => setShowFee((prev) => !prev);
  return (
    <>
      {showFee ? (
        <span>{startSymbol}{!isNaN(rateData) ? parseFloat(rateData).toFixed(2): "0.00"}{endSymbol}</span>
      ) : <span>*******</span>}
       <button type='button' onClick={handleToggle} className='btn btn-sm btn-outline-default p-0 pl-1 pr-1 ml-1 mt--1'>
        {/* Replace with your eye icon */}
        {showFee ? (
          <i className="fa fa-eye-slash" aria-hidden="true" />
        ) : (
          <i className="fa fa-eye" aria-hidden="true" />
        )}
      </button>
    </>
  );
}

export default RateEncryptDecrypt;